<template>
  <form
    :action="payment.postUrl"
    id="form"
    method="POST"
    name="form"
    ref="pay"
  >
    <template v-for="(value, key) in payment.parameters">
      <input
        type="hidden"
        :key="key"
        :name="key"
        :value="value"
      />
    </template>
  </form>
</template>>

<script>
export default {
  props: {
    payment: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.pay.submit()
    })
  }
}
</script>
